export enum NotificationKeys {
  LOGIN_SUCCESS = 'login-success',
  LOGIN_ERROR = 'login-error',
  NO_CHANGES_DETECTED = 'no-changes-detected',
}
